import { useEffect, useState } from "react";
import {
  getSnackbarSuccess,
  isLoadingAction,
  MandatoryStar,
} from "../../Utils/helper";
import { clearCurrentPage } from "../NetworkPortal/ProviderProfileDetails/helper";
import { GenerateInsurerUTRAction, GetReceivablesDataAction } from "../../redux/actions/InsBillAction";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getNetworkMenuId } from "../../Utils/types";
import moment from "moment";

export const InsBankDetails = ({ searchFilter, submitUtr, setSubmitUtr }) => {
  const [data, setData] = useState({
    amountPaid: "",
    utrNumber: "",
    paymentDate: "",
    tds: "",
  });
  const [checkbox, setCheckbox] = useState(false);
  const dispatch = useDispatch();
  const payoutReducer = useSelector((state) => state?.PayoutReducer);
  const location = useLocation();
  console.log(location);

  useEffect(() => {
    if (submitUtr?.rowData?.insurerRequestStatus === "Paid") {
      setData({
        amountPaid: submitUtr?.rowData?.amountPaid,
        utrNumber: submitUtr?.rowData?.utrNumber,
        paymentDate: submitUtr?.rowData?.paymentDate.split("T")[0],
        tds: submitUtr?.rowData?.tds,
      })
      setCheckbox(submitUtr?.rowData?.isFullPayment);
    }
  }, [submitUtr]);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    if (event.target.checkValidity()) {
      const temp = {
        ...data,
        receiveId:  submitUtr?.rowData?.receiveId,
        month: submitUtr?.rowData?.month,
        IsGeneratePayable: true,
        year:submitUtr?.rowData?.year ,
        isFullPayment:checkbox,
        appointmentIds:submitUtr?.rowData?.appointmentId,
        clientIds:[{clientId:submitUtr?.rowData?.clientId}]
      }
      const resp = dispatch(GenerateInsurerUTRAction(temp));
      resp.then((res) => {
        isLoadingAction(true, dispatch);
        if (res?.data?.status === true) {
          clearCurrentPage(dispatch);
          getSnackbarSuccess("success", res?.data?.message, dispatch);
          isLoadingAction(false, dispatch);
          setTimeout(() => {
            dispatch(GetReceivablesDataAction(searchFilter));
          }, 1000);
          handleClose();
        } else {
          getSnackbarSuccess("error", res?.data?.message, dispatch);
          isLoadingAction(false, dispatch);
        }
      });
    }
   
  };

  const handleClose = () => {
    setSubmitUtr({
      isOpen: false,
      rowData: null,
    });
  };
  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black">
          {submitUtr?.rowData?.insurerRequestStatus === "Paid"
            ? "View Details"
            : "Submit Details"}
        </h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={handleClose}
        ></button>
      </div>
            <form className="form-admin" onSubmit={handleSubmit}>
              <div className="modal-body ">
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor="User Type" className="col-form-label">
                      Amount
                      <MandatoryStar />
                    </label>
                    <input
                      name="amountPaid"
                      type="number"
                      required
                      disabled={submitUtr?.rowData?.insurerRequestStatus === "Paid"}
                      min={1}
                      placeholder="Amount Paid"
                      className="form-control form-select-admin inputbgavanish"
                      value={data?.amountPaid}
                      onChange={(e)=>{
                        setData({...data,amountPaid:e.target.value})
                      }}
                    />
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor="User Type" className="col-form-label">
                      TDS
                      <MandatoryStar />
                    </label>
                    <input
                      name="tds"
                      type="number"
                      disabled={submitUtr?.rowData?.insurerRequestStatus === "Paid"}
                      placeholder="TDS"
                      required
                      min={1}
                      className="form-control form-select-admin "
                      value={data?.tds}
                      onChange={(e)=>{
                        setData({...data,tds:e.target.value})
                      }}
                    />
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <label htmlFor="User Type" className="col-form-label">
                      Payment Date
                      <MandatoryStar />
                    </label>
                    <input
                      name="paymentDate"
                      type="date"
                      placeholder="Centre SKU Name"
                      required
                      disabled={submitUtr?.rowData?.insurerRequestStatus === "Paid"}
                      max={new Date().toISOString().split("T")[0]}
                      className="form-control form-select-admin inputbgavanish"
                      onChange={(e)=>{
                        setData({...data,paymentDate:e.target.value})
                      }}
                      value={
                        data?.paymentDate
                          ? data?.paymentDate.split("T")[0]
                          : null
                      }
                    />
                  
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor="User Type" className="col-form-label">
                      UTR No.
                      <MandatoryStar />
                    </label>
                    <input
                      name="utrNumber"
                      type="text"
                      placeholder="UTR No."
                      required
                      disabled={submitUtr?.rowData?.insurerRequestStatus === "Paid"}
                      className="form-control form-select-admin inputbgavanish "
                      value={data?.utrNumber}
                      onChange={(e)=>{
                        setData({...data,utrNumber:e.target.value})
                      }}
                      onKeyPress={(e)=>{
                        if(e.key === " "){
                          e.preventDefault()
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="modal-footer modal-footer-admin justify-content-between accept-reject-btns bottom-0 d-flex mt-4">
                  <div className="col-lg-6 col-md-6 ">
                    <input
                      name="isFullPayment"
                      type="checkbox"
                      checked={checkbox}
                      disabled={submitUtr?.rowData?.insurerRequestStatus === "Paid"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setCheckbox(true);
                        } else {
                          setCheckbox(false);
                        }
                      }}
                    />
                    <label htmlFor="User Type" className="col-form-label ms-3">
                      Full Payment
                    </label>
                  </div>
                  <div>
                    {submitUtr?.rowData?.insurerRequestStatus !== "Paid" && (
                      <button
                        type="submit"
                        disabled={getNetworkMenuId()?.canEdit === false}
                        className="savedetails "
                      >
                        <img src="./../images/save-icon-white.png" alt="" /> &nbsp;
                        Save
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </form>
    </>
  );
};
